module.exports = __webpack_public_path__ + "static/media/descuento-cilindro-Desktop.d3841b51.jpg";